import { Component, OnDestroy } from '@angular/core';
import { TableComponent } from "../../../shared/component/table/table.component";
import { ConfigPaginationService } from '../configuration/configpagination.service';
import { DestroyableComponent } from '../../../shared/services/destroyable.component';
import { takeUntil } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-consumer-list',
  imports: [TableComponent],
  templateUrl: './consumer-list.component.html',
  styleUrl: './consumer-list.component.scss'
})
export class ConsumerListComponent extends DestroyableComponent implements OnDestroy{
  totalcount:number = 0
  siteId:string =''
  constructor(
    private router: Router,
    private pagination:ConfigPaginationService
  ){
    super()
  }
    ngOnInit() {
      this.pagination.totalCount$.subscribe(res=>{
        this.totalcount = res
      })
      this.updateConfigFromRoute();
    }
    private updateConfigFromRoute() {
    
          // 1️⃣ Extract URL segments (without query params)
          const urlTree = this.router.parseUrl(this.router.url);    
          // 2️⃣ Extract query param: siteid
          const encodedId = urlTree.queryParams['siteid'] || localStorage.getItem('site_idLogin');
    
          // 3️⃣ Decode siteid safely
          let decodedSiteId = '';
          if (encodedId) {
            try {
              decodedSiteId = atob(encodedId);
            } catch (e) {
              decodedSiteId = '';
            }
          }
    
          this.siteId = decodedSiteId;  
          const payload ={
            site_id:this.siteId,
            type:'FLAT'
          }
          this.handleFilters(payload)
        }
      handleFilters(payload: any) {
        this.pagination.initFilters(
          payload,
          'Location-Configuration',
          this.destroy$,
          'Consumer List'
        );
      }
    
      handlePageChange(event: { page: number; pageSize: number }) {
        this.pagination.changePage(event, this.destroy$);
      }
    
      
   override ngOnDestroy(): void {
      this.handlereset(false);
    }
    handlereset(show: boolean) {
      if (!show) {
        this.pagination.reset();
      }
    }
}
